<button 
  class="excel-export-btn" 
  (click)="onExportClick()" 
  [disabled]="disabled">
  <mat-icon>{{ icon }}</mat-icon>
  {{ text }}
</button>